import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Attachments from "../../../views/inventory/requests/Attachments";

export default function InternalWorkOrderAttachmentsModal({ id, onClose }) {
  return (
    <Dialog open fullWidth maxWidth="md" onClose={onClose} aria-labelledby="dialog-title">
      <DialogTitle id="dialog-title" sx={{ position: "relative" }}>
        <Typography variant="h2" color="textPrimary" align="center">
          Attachments
        </Typography>
        <IconButton onClick={onClose} size="small" sx={{ position: "absolute", right: 0, top: 0 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box mt={2}>
          <Attachments disabled={false} entityId={id} entityType="internalWorkOrder" />
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="flex-end" width="100%" p={2} pr={3}>
          <Button variant="outlined" onClick={onClose} color="primary">
            Close
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
